import React from "react";
import { Descriptions, Typography } from "antd";
const { Title } = Typography;

const AnswerBotQuotePurchased = ({ resource }) => {
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Purpose">Answer Bot Quote Purchased</Descriptions.Item>
        <Descriptions.Item label="Contact ID">{resource.contact.id}</Descriptions.Item>
        <Descriptions.Item label="Contact Name">
          {resource.payload.contact_name}
        </Descriptions.Item>

        <Descriptions.Item label="Contact Email">
          {resource.payload.contact_email}
        </Descriptions.Item>

        <Descriptions.Item label="Company Name">
          {resource.payload.company_name}
        </Descriptions.Item>

        <Descriptions.Item label="Description">
          {resource.payload.description}
        </Descriptions.Item>

        <Descriptions.Item label="Additional Notes">
          {resource.payload.additional_notes}
        </Descriptions.Item>

        <Descriptions.Item label="Quote Amount">
          {resource.quote_amount.map((q, idx) => (
            <div key={idx}>
              {q.label}: {q.amount}
            </div>
          ))}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default AnswerBotQuotePurchased; 